import { styled } from '@mui/material';

import { generateClasses } from '../../../utils/helper';
import AcadlyToolbarButton from '../../ToolbarButton';

export const imageUploadButtonClasses = generateClasses('ImageUploadButton', [
  'toolbarButton',
  'image',
  'toolbarIcon',
  'imageIcon',
  'label',
]);

export const ToolbarButton = styled(AcadlyToolbarButton)(() => ({
  position: 'relative',
  [`& .${imageUploadButtonClasses.label}`]: {
    position: 'absolute',
    inset: 0,
  },
}));
